import { State, Reducer as UserReducer } from './user.reducer';

export { State };

export const userFeatureKey = 'user';

export const reducer = UserReducer;
